export const buildFaqSchema = (items) => ({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": items.map((faq) => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.answer
        }
    }))
});

export const buildItemListSchema = ({ name, items, getName, getUrl }) => ({
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": name,
    "itemListElement": items.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": getName(item),
        ...(getUrl ? { "url": getUrl(item) } : {})
    }))
});

export const buildWebPageSchema = ({ name, url, description, about, speakable }) => ({
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": name,
    "url": url,
    "description": description,
    "about": about,
    ...(speakable ? {
        "speakable": {
            "@type": "SpeakableSpecification",
            "cssSelector": speakable
        }
    } : {})
});

export const buildHowToSchema = ({ name, description, steps }) => ({
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": name,
    "description": description,
    "step": steps.map((step, i) => ({
        "@type": "HowToStep",
        "position": i + 1,
        "name": step.title,
        "text": step.description
    }))
});

export const buildProductSchemaWithOffers = (product, variants) => {
    const prices = variants
        .map(v => v.sellingPrice || v.mrp)
        .filter(Boolean);
    const lowPrice = prices.length ? Math.min(...prices) : undefined;
    const highPrice = prices.length ? Math.max(...prices) : undefined;

    return {
        "@context": "https://schema.org/",
        "@type": "Product",
        "name": product.name,
        "image": product.imageUrl,
        "description": product.description,
        "brand": {
            "@type": "Brand",
            "name": product.brand || "NISHAD"
        },
        "category": product.category || "Electrical Wires & Cables",
        ...(product.sku && { "sku": product.sku }),
        ...(product.mpn && { "mpn": product.mpn }),
        ...(product.aggregateRating && {
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": product.aggregateRating.ratingValue,
                "reviewCount": product.aggregateRating.reviewCount
            }
        }),
        "additionalProperty": (product.properties || []).map((item) => ({
            "@type": "PropertyValue",
            "name": item.name,
            "value": item.value
        })),
        ...(lowPrice && {
            "offers": {
                "@type": "AggregateOffer",
                "lowPrice": lowPrice,
                "highPrice": highPrice,
                "priceCurrency": "INR",
                "offerCount": prices.length,
                "availability": "https://schema.org/InStock"
            }
        })
    };
};

export const buildComparisonTableSchema = ({ name, description, items }) => ({
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": name,
    "description": description,
    "numberOfItems": items.length,
    "itemListElement": items.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": item.name,
        "description": item.description,
        ...(item.url && { "url": item.url })
    }))
});

